import { connect } from 'react-redux';
import * as React from 'react';
import { redirectWithQueryParams, PagePath, isMobilePhone, redirectToUrl } from '../../helpers/util';
import logo from '../../assets/images/logo-small.png';
import { HeaderLogoDiv, HeaderLogoImg, LinkBackHeader } from '../styled';
import { backToAppLink } from '../../config';

const mapStateToProps = (state: any) => ({
  locationQuery: state.router.location.query,
  pathName: state.router.location.pathname,
});
type Props = ReturnType<typeof mapStateToProps>;

class HeaderLogo extends React.Component<Props> {
  handleBack = () => {
    if (this.props.pathName !== PagePath.complete && (this.props.locationQuery?.origin === 'mobile' || isMobilePhone())) {
      if (this.props.locationQuery?.redirect) {
        redirectToUrl(this.props.locationQuery.redirect);
      } else {
        redirectToUrl(backToAppLink);
      }
    } else {
      redirectWithQueryParams(PagePath.plans, this.props.locationQuery);
    }
  };

  render() {
    const showBackToApp: boolean = this.props.locationQuery?.origin === 'mobile' || isMobilePhone();
    return (
      <>
        <HeaderLogoDiv onClick={() => this.handleBack()}>
          { showBackToApp && <LinkBackHeader className="material-icons">arrow_back</LinkBackHeader> }
          <HeaderLogoImg src={logo} />
        </HeaderLogoDiv>
      </>
    );
  }
}

export default connect<Props>(mapStateToProps)(HeaderLogo);
